import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { currencyCode } from 'Helpers/Geo/Country';
import { couponPencePrice } from 'Helpers/Price/coupon-price';
import SpecialFormattedNumber from 'Components/Price/SpecialFormattedNumber';

function Price({
  tag: Tag,
  price,
  discount,
  type,
  bundlesTiered,
  pence: isPence,
  dontConvert,
  quantity,
  bonusDiscount,
  hideDecimals,
}) {
  if (!price || !Object.keys(price).length > 0) return false;
  if (!currencyCode) return false;
  const pence = price[currencyCode];

  const productDiscount = type !== 'bundle' ? (discount || 0) : 0;

  let actualPrice;
  if (isPence) {
    // Discount in whole pence and convert once, so the price agrees with the
    // cart total rather than rounding a fraction of a penny in pounds
    actualPrice = couponPencePrice(pence, productDiscount, bonusDiscount) / 100;
  } else {
    actualPrice = pence;
    if (productDiscount > 0 && productDiscount <= 1) actualPrice *= 1 - productDiscount;
    if (bonusDiscount > 0 && bonusDiscount <= 1) actualPrice *= 1 - bonusDiscount;
  }

  return (
    <Tag>
      {bundlesTiered && <FormattedMessage id="price.from" defaultMessage="From" />}
      {/* eslint-disable react/style-prop-object */}
      <SpecialFormattedNumber value={actualPrice * quantity} dontConvert={dontConvert} style="currency" hideDecimals={hideDecimals} />
    </Tag>
  );
}

const priceProp = {
  GBP: PropTypes.number,
  EUR: PropTypes.number,
  USD: PropTypes.number,
  CAD: PropTypes.number,
  AUD: PropTypes.number,
  RUB: PropTypes.number,
  JPY: PropTypes.number,
};

Price.propTypes = {
  price: PropTypes.shape(priceProp),
  dontConvert: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  discount: PropTypes.number,
  quantity: PropTypes.number,
  type: PropTypes.oneOf([
    'game',
    'bundle',
    'dlc',
    'book',
    'comic',
  ]),
  bundlesTiered: PropTypes.bool,
  pence: PropTypes.bool,
  hideDecimals: PropTypes.bool,
  bonusDiscount: PropTypes.number,
};

Price.defaultProps = {
  price: priceProp.GBP,
  tag: 'span',
  discount: null,
  quantity: 1,
  dontConvert: false,
  type: 'game',
  pence: true,
  fullPrice: {},
  bundlesTiered: false,
  bonusDiscount: null,
  hideDecimals: false,
};

export default Price;
